var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',[_c('page-header'),_c('main',[_c('keep-alive',[(
            _vm.$route.meta.keepAlive ||
              typeof _vm.$route.meta.keepAlive === 'undefined'
          )?_c('router-view'):_vm._e()],1),(_vm.$route.meta.keepAlive === false)?_c('router-view'):_vm._e()],1),_c('page-footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }